import type { Product } from "@/types/catalog";

function img(seed: string) {
  return `https://picsum.photos/seed/${seed}/400/400`;
}

export const products: Product[] = [
  {
    id: "optus-001",
    slug: "optus-x-start-5-dark-grey",
    title: "Optus X Start 5 4G Smartphone - Dark Grey",
    price: 79,
    wasPrice: 99,
    image: img("optus-x-start-5"),
    badges: [{ type: "bestseller", label: "Bestseller" }],
    seller: "kmart",
    sellerLabel: "Kmart",
    rating: 4.2,
    reviewCount: 48,
    inStock: true,
    categorySlug: "mobile-phones",
    brandSlug: "optus",
    tags: ["optus", "phone", "smartphone", "4g"],
    description:
      "Affordable 4G smartphone with essential features for everyday use.",
    details: ["4G connectivity", "5-inch display", "Includes charger"],
    features: ["Free $39 Optus SIM included", "Dual SIM support"],
  },
  {
    id: "optus-002",
    slug: "optus-x-lite-4g-blue",
    title: "Optus X Lite 4G Smartphone - Blue",
    price: 59,
    image: img("optus-x-lite"),
    badges: [{ type: "trending", label: "Trending Now" }],
    seller: "kmart",
    sellerLabel: "Kmart",
    rating: 4.0,
    reviewCount: 32,
    inStock: true,
    categorySlug: "mobile-phones",
    brandSlug: "optus",
    tags: ["optus", "phone", "smartphone"],
  },
  {
    id: "optus-003",
    slug: "optus-x-pro-5g-black",
    title: "Optus X Pro 5G Smartphone - Black",
    price: 199,
    wasPrice: 249,
    image: img("optus-x-pro"),
    seller: "marketplace",
    sellerLabel: "Officeworks",
    rating: 4.5,
    reviewCount: 12,
    inStock: true,
    categorySlug: "mobile-phones",
    brandSlug: "optus",
    tags: ["optus", "phone", "5g"],
  },
  {
    id: "optus-004",
    slug: "optus-prepaid-sim-starter",
    title: "Optus Prepaid SIM Starter Pack",
    price: 39,
    image: img("optus-sim"),
    seller: "kmart",
    sellerLabel: "Kmart",
    inStock: true,
    categorySlug: "mobile-phones",
    brandSlug: "optus",
    tags: ["optus", "sim", "prepaid"],
  },
  {
    id: "optus-005",
    slug: "optus-x-wave-4g-white",
    title: "Optus X Wave 4G Smartphone - White",
    price: 89,
    image: img("optus-x-wave"),
    badges: [{ type: "bestseller", label: "Bestseller" }],
    seller: "kmart",
    sellerLabel: "Kmart",
    rating: 4.1,
    reviewCount: 21,
    inStock: false,
    categorySlug: "mobile-phones",
    brandSlug: "optus",
    tags: ["optus", "phone"],
  },
  {
    id: "optus-006",
    slug: "optus-x-mini-4g-red",
    title: "Optus X Mini 4G Smartphone - Red",
    price: 49,
    image: img("optus-x-mini"),
    seller: "marketplace",
    sellerLabel: "Marketplace",
    rating: 3.8,
    reviewCount: 8,
    inStock: true,
    categorySlug: "mobile-phones",
    brandSlug: "optus",
    tags: ["optus", "phone"],
  },
  {
    id: "optus-007",
    slug: "optus-phone-case-bundle",
    title: "Optus Phone Case & Screen Protector Bundle",
    price: 19,
    image: img("optus-case"),
    seller: "kmart",
    sellerLabel: "Kmart",
    inStock: true,
    categorySlug: "mobile-phones",
    brandSlug: "optus",
    tags: ["optus", "accessories"],
  },
  {
    id: "sweat-001",
    slug: "womens-fleece-hoodie",
    title: "Women's Fleece Hoodie",
    price: 10,
    image: img("fleece-hoodie"),
    badges: [{ type: "low-price", label: "Low Price" }],
    seller: "kmart",
    sellerLabel: "Kmart",
    rating: 4.6,
    reviewCount: 234,
    colors: [
      { name: "Black", hex: "#1a1a1a" },
      { name: "Grey", hex: "#9e9e9e" },
      { name: "Pink", hex: "#e91e63" },
    ],
    inStock: true,
    categorySlug: "womens-clothing",
    tags: ["sweat", "sweatshirt", "hoodie", "women"],
  },
  {
    id: "sweat-002",
    slug: "mens-sweat-pants",
    title: "Men's Essential Sweat Pants",
    price: 12,
    image: img("sweat-pants"),
    badges: [{ type: "online-only", label: "Online Only" }],
    seller: "kmart",
    rating: 4.3,
    reviewCount: 89,
    colors: [
      { name: "Black", hex: "#1a1a1a" },
      { name: "Navy", hex: "#003DA5" },
    ],
    inStock: true,
    categorySlug: "mens-clothing",
    tags: ["sweat", "pants", "tracksuit", "men"],
  },
  {
    id: "sweat-003",
    slug: "kids-tracksuit-set",
    title: "Kids' Tracksuit Set",
    price: 15,
    image: img("kids-tracksuit"),
    badges: [{ type: "new", label: "New" }],
    seller: "kmart",
    rating: 4.7,
    reviewCount: 56,
    inStock: true,
    categorySlug: "kids-baby",
    tags: ["sweat", "tracksuit", "kids"],
  },
  {
    id: "sweat-004",
    slug: "womens-cropped-sweatshirt",
    title: "Women's Cropped Sweatshirt",
    price: 8,
    image: img("cropped-sweat"),
    badges: [{ type: "low-price", label: "Low Price" }],
    seller: "kmart",
    rating: 4.4,
    reviewCount: 112,
    colors: [
      { name: "White", hex: "#ffffff" },
      { name: "Lilac", hex: "#b39ddb" },
    ],
    inStock: true,
    categorySlug: "womens-clothing",
    tags: ["sweat", "sweatshirt", "women"],
  },
  {
    id: "sweat-005",
    slug: "mens-hoodie-zip",
    title: "Men's Zip Through Hoodie",
    price: 18,
    image: img("mens-zip-hoodie"),
    seller: "kmart",
    rating: 4.2,
    reviewCount: 67,
    inStock: true,
    categorySlug: "mens-clothing",
    tags: ["sweat", "hoodie", "men"],
  },
  {
    id: "sweat-006",
    slug: "womens-sweat-shorts",
    title: "Women's Sweat Shorts",
    price: 7,
    image: img("sweat-shorts"),
    seller: "kmart",
    rating: 4.0,
    reviewCount: 43,
    inStock: true,
    categorySlug: "womens-clothing",
    tags: ["sweat", "shorts", "women"],
  },
  {
    id: "sweat-007",
    slug: "active-sports-hoodie",
    title: "Active & Co Sports Hoodie",
    price: 14,
    image: img("active-hoodie"),
    badges: [{ type: "trending", label: "Trending Now" }],
    seller: "kmart",
    rating: 4.5,
    reviewCount: 98,
    inStock: true,
    categorySlug: "sports-outdoor",
    tags: ["sweat", "hoodie", "active"],
  },
  {
    id: "sweat-008",
    slug: "oversized-sweatshirt",
    title: "Oversized Sweatshirt",
    price: 11,
    image: img("oversized-sweat"),
    seller: "marketplace",
    sellerLabel: "Marketplace",
    rating: 3.9,
    reviewCount: 24,
    inStock: true,
    categorySlug: "womens-clothing",
    tags: ["sweat", "sweatshirt"],
  },
  {
    id: "uno-001",
    slug: "uno-card-game",
    title: "UNO Card Game",
    price: 6,
    image: img("uno-game"),
    images: [
      img("uno-game"),
      img("uno-playing"),
      img("uno-cards"),
      img("uno-family"),
    ],
    seller: "kmart",
    sellerLabel: "Kmart",
    rating: 4.8,
    reviewCount: 512,
    inStock: true,
    categorySlug: "toys",
    brandSlug: "mattel",
    tags: ["uno", "card", "game", "toys", "mattel"],
    description:
      "The classic card game of matching colours and numbers. Easy to pick up and fun for the whole family.",
    details: [
      "Suitable for ages: 7+ years",
      "Includes 108 cards",
      "2-10 players",
    ],
    features: [
      "Match colours and numbers",
      "Special action cards",
      "Portable travel size",
    ],
  },
  {
    id: "toy-002",
    slug: "connect-4-game",
    title: "Connect 4 Game",
    price: 12,
    image: img("connect-4"),
    seller: "kmart",
    rating: 4.6,
    reviewCount: 189,
    inStock: true,
    categorySlug: "toys",
    tags: ["game", "board", "family"],
  },
  {
    id: "toy-003",
    slug: "playing-cards-pack",
    title: "Playing Cards 2 Pack",
    price: 4,
    image: img("playing-cards"),
    seller: "kmart",
    rating: 4.4,
    reviewCount: 76,
    inStock: true,
    categorySlug: "toys",
    tags: ["card", "game"],
  },
  {
    id: "toy-004",
    slug: "monopoly-deal",
    title: "Monopoly Deal Card Game",
    price: 10,
    image: img("monopoly-deal"),
    seller: "kmart",
    rating: 4.7,
    reviewCount: 203,
    inStock: true,
    categorySlug: "toys",
    tags: ["game", "card", "monopoly"],
  },
  {
    id: "home-001",
    slug: "ceramic-dinner-set",
    title: "12 Piece Ceramic Dinner Set",
    price: 29,
    image: img("dinner-set"),
    badges: [{ type: "low-price", label: "Low Price" }],
    seller: "kmart",
    rating: 4.3,
    reviewCount: 145,
    inStock: true,
    categorySlug: "home-living",
    tags: ["kitchen", "dining", "home"],
  },
  {
    id: "home-002",
    slug: "throw-cushion-cover",
    title: "Velvet Throw Cushion Cover",
    price: 8,
    image: img("cushion"),
    seller: "kmart",
    rating: 4.5,
    reviewCount: 88,
    inStock: true,
    categorySlug: "home-living",
    tags: ["decor", "home"],
  },
  {
    id: "home-003",
    slug: "air-fryer-5l",
    title: "5L Digital Air Fryer",
    price: 59,
    wasPrice: 79,
    image: img("air-fryer"),
    badges: [{ type: "bestseller", label: "Bestseller" }],
    seller: "kmart",
    rating: 4.6,
    reviewCount: 312,
    inStock: true,
    categorySlug: "home-living",
    tags: ["kitchen", "air fryer", "appliance"],
  },
  {
    id: "women-001",
    slug: "womens-basic-tee",
    title: "Women's Basic Cotton Tee",
    price: 5,
    image: img("basic-tee"),
    badges: [{ type: "low-price", label: "Low Price" }],
    seller: "kmart",
    rating: 4.2,
    reviewCount: 421,
    colors: [
      { name: "White", hex: "#ffffff" },
      { name: "Black", hex: "#1a1a1a" },
    ],
    inStock: true,
    categorySlug: "womens-clothing",
    tags: ["women", "clothing", "tee"],
  },
  {
    id: "men-001",
    slug: "mens-chino-pants",
    title: "Men's Slim Chino Pants",
    price: 15,
    image: img("chino-pants"),
    seller: "kmart",
    rating: 4.1,
    reviewCount: 156,
    inStock: true,
    categorySlug: "mens-clothing",
    tags: ["men", "pants", "clothing"],
  },
];
